export default __webpack_public_path__ + "static/media/User_Access.d55524eb.svg";